import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

export default function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="flex h-full min-h-[70vh] flex-col items-center justify-center gap-5 px-4 text-center">
      <p className="font-serif text-[72px] italic leading-none tracking-tight text-foreground/90">
        404
      </p>
      <div className="space-y-2">
        <h1 className="text-xl font-semibold tracking-tight text-foreground">
          {t('errors.notFoundTitle')}
        </h1>
        <p className="max-w-[40ch] text-[14.5px] text-muted-foreground">
          {t('errors.notFoundBody')}
        </p>
      </div>
      <Button asChild variant="outline" className="mt-1">
        <Link to="/">{t('errors.goHome')}</Link>
      </Button>
    </div>
  );
}
